const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;

export default Object.freeze({
  ONE_SECOND_MS,
  ONE_MINUTE_MS
});
